<div class="row no-gutters">
  <div class="col">
    <div class="section-icons-container">

      @if (selectedRows.length > 0) {
        <div>
          <div *checkPermission="{ role: 'editor' }" class="icon"
            [ngbTooltip]="translate.instant('buttons.editSelected')" tooltipClass="animation-tooltip"
            placement="top" container="body" triggers="hover">
            @if (section === 'order') {
              <njo-batch-order-edit [selectedRows]="selectedRows">
              </njo-batch-order-edit>
            }
            @if (section === 'budget') {
              <njo-batch-budget-edit [selectedRows]="selectedRows">
              </njo-batch-budget-edit>
            }
          </div>
        </div>
      }

      <div class="icon" (click)="!showSearch ? displaySearchEvent.emit(true) : clearSearchEvent.emit(true)"
        [ngbTooltip]="!showSearch ? translate.instant('buttons.filter')  : translate.instant('buttons.clearFilter')"
        tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
        <div>
          <img [src]="!showSearch ? 'assets/ico/filter.svg' : 'assets/ico/clear-button.svg'"
            alt="!showSearch ? translate.instant('buttons.filter')  : translate.instant('buttons.clearFilter')">
          </div>
        </div>

        @if (enableFilter) {
          <div class="icon" (click)="columnFilter = !columnFilter"
            (clickOutside)="onClickedOutside($event)" [ngbTooltip]="translate.instant('buttons.columnsFilter')"
            tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
            <div>
              <img [src]="'assets/ico/sliders-h-solid.svg'" alt="translate.instant('buttons.columnsFilter')">
            </div>
          </div>
        }

        <div class="icon" (click)="exportCSVEvent.emit(true)" [ngbTooltip]="translate.instant('buttons.exportCSV')"
          tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
          <div>
            <img [src]="'assets/ico/download.svg'" alt="translate.instant('buttons.exportCSV')">
          </div>
        </div>

        <div class="icon" (click)="refreshDataEvent.emit(true)"
          [ngbTooltip]="translate.instant('buttons.refreshData')" tooltipClass="animation-tooltip" placement="top"
          container="body" triggers="hover">
          <div>
            <img [src]="'assets/ico/refresh-icon.svg'" alt="translate.instant('buttons.refreshData')">
          </div>
        </div>

      </div>
    </div>
  </div>

  @if (columnFilter) {
    <div class="column-filter-select" [ngClass]="section === 'errors' ? 'column-filter-error' : ''">
      <ng-select [multiple]="true" [ngModel]="selectedTableColumns" (change)="selectTableColumnsEvent.emit($event)"
        [items]="columnsToDisplayInDropdown" [dropdownPosition]="'bottom'" [closeOnSelect]="false"
        [isOpen]="columnFilter" class="column-display">
        <ng-template ng-header-tmp>
          <div class="select-utils">
            <span (click)="selectAllColumnsEvent.emit(true)">{{'columnName.selectAll' | translate}}</span> | <span
          (click)="unselectAllColumnsEvent.emit(true)">{{'columnName.selectNone' | translate}}</span>
        </div>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" class="option column-options">
        <div isEllipsisActive class="dropdown-select-wrapper" style="height: 20px !important; margin-top: -6px;">
          <input style="height: 11px;" id={{item.name}} type="checkbox" [ngModel]="item.selected" />&nbsp;
          <span style="max-width: 290px; font-size: 14px;" class="dropdown-select-label">{{'columnName.' +
          item.name | translate }}</span>
        </div>
      </ng-template>
    </ng-select>
  </div>
}